// SSO hand-off → app_smileseasons (the CRM) patient Chart.
//
// Unlike the doctor portal (a token-in-localStorage SPA), this app keeps the
// Xano auth token server-side in an httpOnly session cookie — the browser
// never sees it. So we open a server route that reads the token from the
// session and emits a self-submitting POST form to the CRM's /__app/sso. The
// token rides in the POST body, never the URL. No second login.

/** Open a patient's Chart history in the CRM in a new tab. */
export function openPatientChart(patientId) {
  if (!patientId) return
  window.open(`/api/sso/patient/${encodeURIComponent(patientId)}`, '_blank', 'noopener')
}
